/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function ArrowDownLeft({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" fillRule="evenodd" d="M12.313 3.687a.6.6 0 0 1 0 .848L5.56 11.29h4.209a.6.6 0 1 1 0 1.2H4.11a.6.6 0 0 1-.6-.6V6.232a.6.6 0 1 1 1.2 0v4.209l6.754-6.754a.6.6 0 0 1 .848 0" clipRule="evenodd" /></svg>;
}
;